/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @description 观演人
 */
import getViewTime from "./getViewTime";
import updateViewerTop from "./updateViewerTop";
import deleteViewer from "./deleteViewer";
import saveViewer from "./saveViewer";
import getViewers from "./getViewers";

export class ViewerApi {
  constructor(
    public getViewTime: (
      success?: ({
        data,
        ext,
        state,
        errors,
      }: {
        data: number;
        ext: ObjectMap;
        state: "SUCCESS" | "FAIL" | "EXCEPTION";
        errors?: Array<string>;
      }) => any,
      fail?: (error: string) => any
    ) => void,

    public updateViewerTop: (
      id: string,

      success?: ({
        data,
        ext,
        state,
        errors,
      }: {
        data: boolean;
        ext: ObjectMap;
        state: "SUCCESS" | "FAIL" | "EXCEPTION";
        errors?: Array<string>;
      }) => any,
      fail?: (error: string) => any
    ) => void,

    public deleteViewer: (
      id: string,

      success?: ({
        data,
        ext,
        state,
        errors,
      }: {
        data: boolean;
        ext: ObjectMap;
        state: "SUCCESS" | "FAIL" | "EXCEPTION";
        errors?: Array<string>;
      }) => any,
      fail?: (error: string) => any
    ) => void,

    public saveViewer: (
      viewer: member.Viewer,

      success?: ({
        data,
        ext,
        state,
        errors,
      }: {
        data: boolean;
        ext: ObjectMap;
        state: "SUCCESS" | "FAIL" | "EXCEPTION";
        errors?: Array<string>;
      }) => any,
      fail?: (error: string) => any
    ) => void,

    public getViewers: (
      success?: ({
        data,
        ext,
        state,
        errors,
      }: {
        data: Array<member.CommonlyDTO>;
        ext: ObjectMap;
        state: "SUCCESS" | "FAIL" | "EXCEPTION";
        errors?: Array<string>;
      }) => any,
      fail?: (error: string) => any
    ) => void
  ) {}
}

export default {
  getViewTime,
  updateViewerTop,
  deleteViewer,
  saveViewer,
  getViewers,
} as ViewerApi;
